module.exports = __webpack_public_path__ + "resources/img/intro-2.6b0276e9.png";